var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 33,
    viewBox: "0 0 35 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 33,
    fill: "url(#pattern0_9_21)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_9_21",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9_21",
    transform: "matrix(0.0104762 0 0 0.0111111 0.0285714 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_9_21",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADd0lEQVR4nO3cO2gUQRjA8U8RLYyCiohoJNhY+Ig2MaJBsFErS7UylQR8YbA4jS8QLGxMtNMiokVAQSyMTbQRREstNKhgMC8REjUPSOKDvwyMIIF77O7t7Mzm+8FBINxl959hdm7vdkWUUkoppZRSSqUPWA0cBq4DPUAv8M0+ZoAh4BXwEDgP7AIWOdi08AFLgBPAC+AP0RWy3gevAcuAa8AP4ruU9X54C5gHtAAjCQJr5FKAlcDjhIE1cilAvT2YaeS0ALsTzsU6kssBNgHfNXKKgDVAv0ZON/J8uzbW6SLl0Mc1sptl3Lge+NIPfVEjpx95IfBFl3Dph96jkR0AriQIXediG3MBeJYgdLPjbT1rpjoJEfAhQehOh9t52f7NnRIiYCxB6D7HkY1zEiJggmTqHEY2HkiISH4qtNlhZOOlhAh4kzB0p8PIRr+ECLiXMHSfw8jGhIQIOE1ydY4iG6MSImBzFUI3O4psDEuogHdZz9MVRjZ6JVRAV5bzdITIxiMJEXCG6hgG7gNHgfUpRTauSmiAAunpA+4AR4odLGNENg5KSEg3ctnwMSP/NF9Nkzk4Xbj2VEKB+5FcTS0SAsIdydgvWS4W3xF2ZOOC+I6wpwvjK7BcfEb4I9k4JD4jH5G7xWfkI/InYJX4inxEHgU2iK9ycODDfmDcJL7KyUgeAraJr3Iykp+bL8OLr3IwkseAU+bL8OIrj0ZyF/A24nMG7favEJ95FLnw3zZtBE7aU6Kvgc/22vAR+4/osadIm4AF4juPpos2ySuN7IBGdkAjO6CRHdDIDgCt+KEgeQXsA35nXZicL+FqE172UC35HckGcLvEzk8B7UCD+WTYPrYDHcB01RLPgcjrgF9Fdn4A2FLmzjEDGjnZnQamSkWeFXtaR3L5UE+KRGqP8Bo3dLooH+ljkUgNEUI3xgid7zl5NmCySIiaCK9REzFyfpdwMS6yjBJ6qUb2a+ooyFxV4mDYEeE1bmrk+Ms7s2Srr+D5W+1thXUkV/D2u9QblvoykQc1coWAWyViTdt1cqNdXZjHDjtdzGjkCIC1KZxUKkTZhjkD2FvF06RtWe+P1+xt3uPc4v0f89zWrPcjCMD+mHfAHQcOZL39Id4Jt6OCgx12xXJXb5eW/Fz1MXPJAfDenheZtD9329/VVu9frJRSSimllFJKqukvtdUQuztu1pIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.e0aa2a2b798feb45277f65a0c8c030a3.svg";
export { ForwardRef as ReactComponent };